import { CSSObject } from '@emotion/react'
import { fonts } from '@opallabs/pulsar'

const postDimensions: Record<string, string> = {
  mobileStandard: '375px',
  desktopStandard: '598px',
}

const getDisplay = (display: string): CSSObject => ({
  backgroundColor: 'white',
  fontFamily: fonts.helvetica,
  width: postDimensions[display],
})

const styles = {
  getDisplay,
}

export { styles }
